import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    OTP,
    otpFail,
    otpSuccess
} from '../action/otpAction'

// api 
import otpApi from '../api/otpApi'

export function* otpSaga(action) {
    try {
        const response = yield call(() => otpApi(action.params))
        if (response.data.status === 1) {
            yield put(otpSuccess(response, action))
        } else {
            yield put(otpFail(response, action))
        }
    }
    catch (e) {
        yield put(otpFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(OTP, otpSaga)
}